export const MODEL_FAMILIES = ['haiku', 'sonnet', 'opus', 'fable'] as const;

// Mirrors `requiredRerouteModelFamilies` in policies, which omits `fable` so
// policies authored before Fable existed still validate on update.
export const REQUIRED_MODEL_FAMILIES = [
  'haiku',
  'sonnet',
  'opus',
] as const satisfies readonly ModelFamily[];

export const APPLICATION_TYPES = ['claude-code'] as const;

export type ModelFamily = (typeof MODEL_FAMILIES)[number];
export type ApplicationType = (typeof APPLICATION_TYPES)[number];
export type ModelFamilyRerouteEntry = {
  privateModelId: string;
};

export type RerouteConfig = {
  enabled: boolean;
  modelFamilyReroutes: Partial<Record<ModelFamily, ModelFamilyRerouteEntry>>;
  applicationType: ApplicationType;
};

export const MODEL_FAMILY_LABELS: Record<ModelFamily, string> = {
  haiku: 'Haiku',
  sonnet: 'Sonnet',
  opus: 'Opus',
  fable: 'Fable',
};

export const APPLICATION_TYPE_LABELS: Record<ApplicationType, string> = {
  'claude-code': 'Claude Code',
};
